import $ from "jquery";
import { connect } from "react-redux";
import React from "react";
import { browserHistory } from "react-router";

import * as actions from "../actions/actions";
let Loading = require("./loading");
import FortMemberHeader from "./fort-member-header";

class FortCreatorInfo extends React.Component {
    constructor(props) {
        super(props);

        this.props.fetchCreator(this.props.creatorId);

        this.toggleNavHack();

        this.state = {
            disableText: "Disable member"
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.creator.creator_info) {
            this.setState({
                important: nextProps.creator.creator_info.important_note
            });
        }
    }

    disableUser(creator) {
        if (this.state.disableText === "Disable member") {
            this.setState({ disableText: "Are you sure?" });
        } else {
            this.props.disableCreator(creator.id);
        }
    }

    featureUser() {
        if (this.props.creator.featured) {
            this.props.toggleFeatureCreator(this.props.creator, "remove");
        } else {
            this.props.toggleFeatureCreator(this.props.creator, "add");
        }
    }

    getNoteStatus(creator) {
        let noteStatus = "";

        if (this.props.creator.creator_info) {
            if (creator.creator_info.important_note) {
                noteStatus = "red";
            }
        }

        return noteStatus;
    }

    render() {
        let creator = this.props.creator;

        if (creator) {
            let creatorInfo = this.renderCreatorInfo(creator),
                disableButton = this.renderDisableButton(creator),
                lastDownloadDate = this.renderLastDownloadDate(creator),
                featureCreatorButton = this.renderFeatureCreatorButton(creator),
                suspensionReason = this.renderSuspensionReason(creator),
                notesAndHistory = this.renderNotesAndHistory(creator),
                renderHistory = this.renderHistory(creator),
                stripeData = this.renderStripeData(creator).stripeData,
                receiptLink = this.renderStripeData(creator).receiptLink,
                subscriptions = this.renderSubscriptionInfo(creator),
                suspendActionBtn = this.rendersuspensionButton(creator),
                teams = this.renderTeamData(creator),
                userOperatingSystem = this.renderUserEnvironmentInfo(creator)
                    .os,
                userBrowserHistory = this.renderUserEnvironmentInfo(creator)
                    .browser;

            return (
                <div>
                    {suspensionReason}
                    <FortMemberHeader />
                    <section>
                        <div className="container">
                            <div className="six columns">
                                <div className="admin-table margin-t-xl margin-b-xl">
                                    <table
                                        id="account-info"
                                        className="margin-t-xl"
                                    >
                                        <tbody>
                                            <tr>
                                                <td colSpan="2">
                                                    <h2>Account Info</h2>
                                                </td>
                                            </tr>
                                            <tr
                                                className={
                                                    creator.is_active == "True"
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>Active</td>
                                                <td className="is_active">
                                                    <div>
                                                        {creator.is_active ==
                                                        "True"
                                                            ? "True"
                                                            : "False"}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>ID</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.id}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Username</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.username}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Full Name</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={
                                                            creator.full_name
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={`mailto: ${
                                                            creator.email
                                                        }`}
                                                        title="Email them"
                                                    >
                                                        {" "}
                                                        Email
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.email}
                                                    />
                                                </td>
                                            </tr>
                                            <tr
                                                className={
                                                    creator.is_verified ==
                                                    "True"
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>Verified Email</td>
                                                <td className="is_verified">
                                                    <div>
                                                        {creator.is_verified ==
                                                        "True"
                                                            ? "True"
                                                            : "False"}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>PayPal email</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={
                                                            creator.paypal_email
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Join Date</td>
                                                <td> {creator.date_joined} </td>
                                            </tr>
                                            <tr>
                                                <td>Last Login</td>
                                                <td>{creator.last_login}</td>
                                            </tr>
                                            <tr>
                                                <td>Subscriptions</td>
                                                <td>{subscriptions}</td>
                                            </tr>
                                            {stripeData}
                                            {receiptLink}
                                            <tr>
                                                <td>Download History</td>
                                                <td>
                                                    <a
                                                        href={`/${
                                                            creator.username
                                                        }/settings/icon-history/`}
                                                        target="_blank"
                                                    >
                                                        Download History
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={`/fort/members/${
                                                            creator.id
                                                        }/downloads/`}
                                                    >
                                                        Premium Download
                                                    </a>
                                                </td>
                                                <td>{lastDownloadDate}</td>
                                            </tr>
                                            <tr>
                                                <td>Education</td>
                                                <td>
                                                    <a
                                                        href={`/fort/members/${
                                                            creator.id
                                                        }/edu/`}
                                                    >
                                                        View Edu Info
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="six columns">
                                <div className="admin-table margin-t-xl margin-b-xl">
                                    {teams}
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td colSpan="2">
                                                    <h2>Basic Info</h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Language</td>
                                                <td>{creator.language}</td>
                                            </tr>
                                            <tr>
                                                <td>City</td>
                                                <td>{creator.city}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={creator.website}
                                                        target="_blank"
                                                    >
                                                        Website
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.website}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={creator.behance}
                                                        target="_blank"
                                                    >
                                                        Behance
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.behance}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={creator.dribbble}
                                                        target="_blank"
                                                    >
                                                        Dribbble
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.dribbble}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={creator.facebook}
                                                        target="_blank"
                                                    >
                                                        Facebook
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.facebook}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={creator.google}
                                                        target="_blank"
                                                    >
                                                        Google+
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.google}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={creator.linkedin}
                                                        target="_blank"
                                                    >
                                                        LinkedIn
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.linkedin}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <a
                                                        href={creator.twitter}
                                                        target="_blank"
                                                    >
                                                        Twitter
                                                    </a>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={creator.twitter}
                                                    />
                                                </td>
                                            </tr>
                                            <tr
                                                className={
                                                    creator.is_staff == "True"
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>Staff</td>
                                                <td className="is_staff">
                                                    <div>
                                                        {creator.is_staff ==
                                                        "True"
                                                            ? "True"
                                                            : "False"}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr
                                                className={
                                                    creator.is_superuser ==
                                                    "True"
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>Super User</td>
                                                <td className="is_superuser">
                                                    <div>
                                                        {creator.is_superuser ==
                                                        "True"
                                                            ? "True"
                                                            : "False"}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr
                                                className={
                                                    creator.is_developer == true
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>
                                                    API Developer Access{" "}
                                                    {creator.is_developer}
                                                </td>
                                                <td className="is_developer">
                                                    <div>
                                                        {creator.is_developer ==
                                                        true
                                                            ? "True"
                                                            : "False"}
                                                    </div>
                                                </td>
                                            </tr>

                                            {userOperatingSystem}
                                            {userBrowserHistory}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div
                            className="container"
                            style={{ borderTop: "solid 1px #cccccc" }}
                        >
                            <div className="twelve columns">
                                {notesAndHistory}
                            </div>
                        </div>
                        <div className="container">
                            <div className="six columns">
                                <div className="admin-table margin-t-xl margin-b-xl">
                                    <table
                                        id="creator-info"
                                        className="margin-t-xl"
                                    >
                                        <tbody>
                                            <tr>
                                                <td colSpan="2">
                                                    <h2>Creator Info</h2>
                                                </td>
                                            </tr>
                                            <tr
                                                className={
                                                    creator.is_designer == true
                                                        ? "dot-true"
                                                        : "dot-false"
                                                }
                                            >
                                                <td>Designer</td>
                                                <td className="is_designer">
                                                    <div>
                                                        {creator.is_designer ==
                                                        true
                                                            ? "True"
                                                            : "False"}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>PayPal email</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={
                                                            creator.paypal_email
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                        {creatorInfo}
                                    </table>
                                    <div className="margin-t-xl">
                                        {featureCreatorButton}
                                    </div>
                                </div>
                            </div>
                            <div className="six columns">
                                <div className="admin-table">
                                    {renderHistory}
                                </div>
                            </div>
                        </div>

                        <div className="kinda-danger-zone user-actions container margin-t-xl">
                            <h2>Kinda Dangerous Zone</h2>
                            <p>Proceed with extreme caution.</p>
                            <div className="display-flex ">
                                <div
                                    className="padding-l"
                                    style={{
                                        width: "100%",
                                        "text-align": "left"
                                    }}
                                >
                                    {suspendActionBtn}
                                    <p>
                                        Suspending this member sets their
                                        account to inactive. They will not be
                                        able to upload any icons, log in, or
                                        download until they are unsuspended.
                                    </p>
                                </div>
                                <div
                                    className="padding-l"
                                    style={{
                                        width: "100%",
                                        "text-align": "left"
                                    }}
                                >
                                    {disableButton}
                                    <p>
                                        Disabling this member sets their account
                                        to inactive, and disables all of their
                                        icons and collections. Disabling a user
                                        cannot be undone and should be done with
                                        extreme caution.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            );
        } else {
            return <Loading />;
        }
    }

    renderCreatorInfo(creator) {
        let creatorInfo;

        if (creator.is_designer && creator.creator_info !== undefined) {
            creatorInfo = (
                <tbody>
                    <tr
                        className={
                            creator.featured == true ? "dot-true" : "dot-false"
                        }
                    >
                        <td>Featured on Homepage</td>
                        <td className="featured">
                            <div>
                                {creator.featured == true ? "True" : "False"}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Rating</td>
                        <td>{creator.creator_info.star_rating}</td>
                    </tr>
                    <tr>
                        <td>Icon Percentage</td>
                        <td>{creator.creator_info.icon_percentage}%</td>
                    </tr>
                </tbody>
            );
        }

        return creatorInfo;
    }

    renderCreatorSocialAccounts(creator) {
        let soccialAccounts;

        return socialAccounts;
    }

    renderDisableButton(creator) {
        let button;

        if (creator.is_active === "True") {
            button = (
                <button
                    className="button red full-width"
                    onClick={this.disableUser.bind(this, creator)}
                >
                    {this.state.disableText}
                </button>
            );
        } else {
            let disabledText = "User was disabled";

            if (creator.is_designer && creator.creator_info) {
                if (creator.creator_info.is_suspended) {
                    // user was suspended
                    disabledText = "User was suspended";
                }
            }

            button = (
                <button className="button ui_broken-heart disabled full-width">
                    {disabledText}
                </button>
            );
        }

        return button;
    }

    renderFeatureCreatorButton(creator) {
        let featureButton = null;

        if (creator.is_designer && creator.creator_info) {
            featureButton = (
                <button
                    className={`button yellow full-width`}
                    onClick={this.featureUser.bind(this)}
                >
                    {creator.featured ? "Unfeature Creator" : "Feature Creator"}
                </button>
            );
        }

        return featureButton;
    }

    renderHistoryEvents(creator) {
        let historyEvents = [];

        if (creator.is_designer && creator.creator_info) {
            let i = 0;
            creator.creator_info.events.forEach(event => {
                let notes;
                if (event.notes) {
                    notes = <div className="weight-light">{event.notes}</div>;
                }
                historyEvents.push(
                    <tr key={i} style={{ verticalAlign: "top" }}>
                        <td className="event-date">{event.date}</td>
                        <td
                            className="event-name"
                            style={{ fontWeight: "900" }}
                        >
                            <span className="weight-medium">{event.event}</span>
                            {notes}
                        </td>
                    </tr>
                );
                i++;
            });
        }

        return historyEvents;
    }

    renderLastDownloadDate(creator) {
        let lastDownloadDate;

        if (creator.last_premium_download) {
            lastDownloadDate = (
                <span>
                    {creator.last_premium_download}{" "}
                    <a href={`/fort/members/${creator.id}/downloads/`}>
                        View all
                    </a>
                </span>
            );
        }

        return lastDownloadDate;
    }
    renderHistory(creator) {
        let historyEvents = this.renderHistoryEvents(creator),
            historyStyle = {
                maxHeight: "500px",
                minHeight: "200px",
                width: "100%",
                border: "1px solid gainsboro",
                padding: "8px",
                background: "white",
                overflow: "scroll"
            };

        return (
            <div className="history margin-t-xl margin-b-xl">
                <table style={historyStyle}>
                    <tbody>
                        {historyEvents}
                        <tr
                            style={{
                                textAlign: "center"
                            }}
                        >
                            <td colSpan="2">End of History</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
    renderSuspensionReason(creator) {
        let suspensionReason,
            textAreaStyle = {
                width: "100%",
                padding: "24px",
                margin: "24px 0",
                fontSize: "18px"
            };

        if (creator.creator_info) {
            if (creator.creator_info.is_suspended) {
                suspensionReason = (
                    <section
                        style={{
                            background: "#F44E4E",
                            color: "#FFFFF",
                            textAlign: "center"
                        }}
                    >
                        <div className="creator-suspension-reason padding-xl container">
                            <h4 className="ui_flag white">
                                <span
                                    style={{
                                        fontSize: "24px",
                                        color: "#FFFFFF",
                                        fontWeight: "bold",
                                        paddingLeft: "10px"
                                    }}
                                >
                                    This user has been suspended
                                </span>
                            </h4>
                            <textarea
                                style={textAreaStyle}
                                placeholder="suspension Reason"
                                value={creator.creator_info.suspension_reason}
                                readOnly
                            />
                        </div>
                    </section>
                );
            }
        }
        return suspensionReason;
    }
    renderNotesAndHistory(creator) {
        let creatorNotesClass = ["creator-notes"],
            notesAndHistory,
            noteStatusColor = this.getNoteStatus(creator),
            textAreaStyle = {
                minHeight: "250px",
                width: "100%",
                padding: "24px",
                margin: "24px 0"
            };
        if (creator.creator_info) {
            if (this.state.important) {
                creatorNotesClass.push("important-notes");
            }

            return (
                <div className="twelve columns notes-history">
                    <div className={creatorNotesClass.join(" ")}>
                        <textarea
                            style={textAreaStyle}
                            className=""
                            ref="creator-note"
                            placeholder="Creator Notes"
                            defaultValue={creator.creator_info.notes}
                        />
                        <div className="display-flex">
                            <div
                                className="save-as-important"
                                style={{
                                    margin: "20px 0 0",
                                    fontSize: "18px",
                                    display: "flex",
                                    width: "50%"
                                }}
                            >
                                <input
                                    type="checkbox"
                                    name="saveAsImportant"
                                    ref="saveAsImportant"
                                    id="saveAsImportant"
                                    onChange={this.setImportant.bind(this)}
                                    checked={this.state.important}
                                    style={{
                                        marginRight: "8px",
                                        height: "16px",
                                        marginTop: "4px"
                                    }}
                                />
                                <label htmlFor="saveAsImportant">
                                    Important
                                </label>
                            </div>
                            <button
                                style={{ width: "50%" }}
                                className={`button full-width ${noteStatusColor}`}
                                onClick={this.saveNote.bind(this)}
                            >
                                Save Note
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return notesAndHistory;
    }

    renderStripeData(creator) {
        let data = {};

        if (creator.stripe_id) {
            data.stripeData = (
                <tr>
                    <td>
                        <a
                            target="_blank"
                            href={`https://dashboard.stripe.com/customers/${
                                creator.stripe_id
                            }`}
                        >
                            Stripe ID
                        </a>
                    </td>
                    <td>
                        <input type="text" readOnly value={creator.stripe_id} />
                    </td>
                </tr>
            );
            data.receiptLink = (
                <tr>
                    <td>Invoices</td>
                    <td>
                        <a
                            href={`/fort/members/${
                                creator.username
                            }/customer/invoices/`}
                            onClick={this.viewReceipts.bind(this)}
                        >
                            View Invoices
                        </a>
                    </td>
                </tr>
            );
        } else {
            data.stripeData = (
                <tr>
                    <td>Stripe ID</td>
                    <td>
                        <span>None</span>
                    </td>
                </tr>
            );
            data.receiptLink = null;
        }

        return data;
    }

    renderSubscriptionInfo(creator) {
        let index = 0,
            subscriptions = " ";

        creator.plans.forEach(sub => {
            let subscription = sub.plan_id;

            if (sub.upgrade_token_id) {
                subscription = subscription.concat(
                    ` (${sub.upgrade_token_id})`
                );
            }

            if (index !== creator.plans.length - 1) {
                subscription = subscription.concat(", ");
            } else {
                subscription = subscription.concat("");
            }

            subscriptions = subscriptions.concat(`${subscription} `);
            index = index + 1;
        });

        return subscriptions;
    }

    rendersuspensionButton(creator) {
        let button = (
            <button
                className="button red full-width"
                onClick={this.suspendUser.bind(this, creator)}
            >
                Suspend member
            </button>
        );

        if (creator.is_designer && creator.creator_info) {
            if (creator.creator_info.is_suspended) {
                button = (
                    <button
                        className="button green full-width"
                        onClick={this.unSuspendUser.bind(this, creator)}
                    >
                        Unsuspend member
                    </button>
                );
            }
        }

        return button;
    }

    renderAccountData(creator) {}

    renderTeamData(creator) {
        if (creator.organization_keys.length > 0) {
            let teams = [];

            creator.organization_keys.forEach(teamId => {
                let team = creator.organizations[teamId];

                teams.push(
                    <table className="team margin-b-xl" key={teamId}>
                        <tbody>
                            <tr>
                                <td colSpan="2">
                                    <h2>Team Info</h2>
                                </td>
                            </tr>
                            <tr>
                                <td>Team name</td>
                                <td>
                                    <input
                                        type="text"
                                        readOnly
                                        value={team.name}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <a href={`/${team.slug}`}>Slug</a>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        readOnly
                                        value={team.slug}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <a
                                        href={
                                            "/fort/members/" +
                                            team.owner_id +
                                            "/"
                                        }
                                    >
                                        Team owner
                                    </a>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        readOnly
                                        value={team.owner_name}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>{`${creator.username}'s role`}</td>
                                <td>{team.role}</td>
                            </tr>
                            <tr>
                                <td>Organization id</td>
                                <td>
                                    <input
                                        type="text"
                                        readOnly
                                        value={team.id}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>User id</td>
                                <td>
                                    <input
                                        type="text"
                                        readOnly
                                        value={team.user_id}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <a
                                        target="_blank"
                                        href={`https://dashboard.stripe.com/customers/${
                                            team.customer_id
                                        }`}
                                    >
                                        Customer
                                    </a>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        readOnly
                                        value={team.customer_id}
                                    />
                                </td>
                            </tr>
                            <tr
                                className={
                                    team.plan_status.status == "active"
                                        ? "dot-true"
                                        : "dot-false"
                                }
                            >
                                <td>Plan status</td>
                                <td>
                                    <div>
                                        {team.plan_status.status == "active"
                                            ? "Active"
                                            : "Inactive"}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Cancel at period end</td>
                                <td>{team.plan_status.cancel_at_period_end}</td>
                            </tr>
                            <tr>
                                <td>Period end date</td>
                                <td>{team.plan_status.current_period_end}</td>
                            </tr>
                            <tr>
                                <td>Seats available</td>
                                <td>
                                    {team.seats.total - team.seats.taken} ({
                                        team.seats.taken
                                    }{" "}
                                    of {team.seats.total} taken)
                                </td>
                            </tr>
                            <tr>
                                <td>Invited</td>
                                <td>{team.seats.invited} </td>
                            </tr>
                            <tr>
                                <td>
                                    <a href={`/${team.slug}/members/`}>
                                        Members
                                    </a>
                                </td>
                                <td>{team.seats.members}</td>
                            </tr>
                        </tbody>
                    </table>
                );
            });

            return <span>{teams}</span>;
        } else {
            return null;
        }
    }

    renderUserEnvironmentInfo(creator) {
        let userBrowserHistory, userOperatingSystem;

        if (creator.user_environment) {
            userOperatingSystem = (
                <tr>
                    <td>Operating system</td>
                    <td>{creator.user_environment.os}</td>
                </tr>
            );
            userBrowserHistory = (
                <tr>
                    <td>Browser version</td>
                    <td>{creator.user_environment.browser}</td>
                </tr>
            );
        }
        return { browser: userBrowserHistory, os: userOperatingSystem };
    }

    saveNote() {
        let creator = Object.assign({}, this.props.creator),
            note = this.refs["creator-note"],
            important = this.state.important;

        if (note) {
            creator.note = note.value;
            this.props.saveCreatorNote(creator, important);
        }
    }

    setImportant(e) {
        let important = this.state.important;

        if (this.state.important) {
            important = false;
        } else {
            important = true;
        }

        this.setState({
            important: important
        });
    }

    suspendUser(creator) {
        this.props.showModal(null, "SUSPEND_CREATOR", {
            creator: creator,
            referringComponent: "Fort"
        });
    }

    toggleNavHack() {
        // this is a hack to fix the fort sandwich nav in the top left

        $("document").ready(function() {
            let $admin_sidebar,
                $admin_status_header,
                $footer,
                $is_active,
                $main_content,
                $search,
                $sticky_wrapper,
                toggle;
            toggle = 0;
            $admin_sidebar = $("#admin-sidebar");
            $admin_status_header = $("#admin-stats-header");
            $search = $("#search");
            $sticky_wrapper = $(".sticky-wrapper");
            $main_content = $("#main-content");
            $footer = $("#footer");
            $is_active = $(".is_active");

            $("#sandwich-stack").on("click", function(e) {
                e.preventDefault();

                if (toggle === 0) {
                    $admin_status_header.css("left", "300px");
                    $sticky_wrapper.css("left", "300px");
                    $search.css("left", "300px");
                    $main_content.css("left", "300px");
                    $footer.css("left", "300px");
                    $admin_sidebar.css("left", "0");
                    toggle = 1;
                } else {
                    $admin_status_header.css("left", "0");
                    $sticky_wrapper.css("left", "0");
                    $search.css("left", "0");
                    $main_content.css("left", "0");
                    $footer.css("left", "0");
                    $admin_sidebar.css("left", "-300px");
                    toggle = 0;
                }
            });
        });
    }

    unSuspendUser(creator) {
        this.props.unSuspendCreator(creator.id);
    }

    viewReceipts(e) {
        e.preventDefault();
        browserHistory.push(
            `/fort/members/${this.props.creator.id}/customer/invoices/`
        );
    }
}

function mapStateToProps(state, ownProps) {
    let creator;

    if (state.creator.keys) {
        creator = state.creator[state.creator.keys[0]];
    }

    return { creator };
}

module.exports = connect(mapStateToProps, {
    disableCreator: actions.disableCreator,
    toggleFeatureCreator: actions.toggleFeatureCreator,
    showModal: actions.showModal,
    saveCreatorNote: actions.saveCreatorNote,
    unSuspendCreator: actions.unSuspendCreator,
    fetchCreator: actions.fetchCreator
})(FortCreatorInfo);
